module.exports = __webpack_public_path__ + "img/logo.6ae35096.png";